import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { HierarchyCategoryServant } from '../../global/servants/hierarchy_category_servant';
import { ITransferMajorsDatasource } from '../datasources/transfer_majors_datasource';

angular.module('capability-ng-transfer').factory(
  'loadTransferCategoryMajorsCommand',
  (
    defineCommand: IDefineCommand,
    $http: ng.IHttpService,
    QueryMediator: IQueryMediator,
    ngHierarchyCategoryServant: HierarchyCategoryServant,
    ngTransferMajorsDatasource: ITransferMajorsDatasource
  ): ICommand => {
    return defineCommand('loadTransferCategoryMajorsCommand', function(deferred: ng.IDeferred<IQuery[]>): void {
      $http({
        method: 'GET',
        url: 'catalog/program/',
        params: {
          paginate: 0
        }
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          ngTransferMajorsDatasource.write(response.data.results);

          deferred.resolve(QueryMediator.runQueries(ngTransferMajorsDatasource));
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_category_majors_command.ts